// componentes-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ".csv, .xlsx ou .xls · até 5 MB": ".csv, .xlsx o .xls · hasta 5 MB",
    "A ordem não importa": "El orden no importa",
    "Acre": "Acre",
    "Ajudou?": "¿Ayudó?",
    "Alagoas": "Alagoas",
    "Amapá": "Amapá",
    "Amazonas": "Amazonas",
    "Arquivo está vazio": "El archivo está vacío",
    "Arquivo já foi importado": "El archivo ya fue importado",
    "Arraste e solte ou clique para selecionar": "Arrastre y suelte o haga clic para seleccionar",
    "As linhas abaixo foram ignoradas porque têm dados faltando ou inválidos. Corrija e reenvie se necessário.": "Las líneas abajo fueron ignoradas porque tienen datos faltantes o inválidos. Corrija y reenvíe si es necesario.",
    "Assistente de Suporte": "Asistente de soporte",
    "Atenção": "Atención",
    "Atual:": "Actual:",
    "Ação": "Acción",
    "Bahia": "Bahía",
    "CPF": "CPF",
    "Cadastre vários frentistas de uma vez por planilha": "Registre varios playeros a la vez mediante una planilla",
    "Caixa de entrada": "Bandeja de entrada",
    "Carregando locais…": "Cargando lugares…",
    "Ceará": "Ceará",
    "Conta marcada como verificada!": "¡Cuenta marcada como verificada!",
    "Contexto": "Contexto",
    "Contextos Mais Usados": "Contextos más usados",
    "Cupom estornado": "Cupón revertido",
    "Cupom sem locais configurados. Será resgatado no local de origem": "Cupón sin lugares configurados. Será canjeado en el lugar de origen",
    "Custo Total": "Costo total",
    "Data Inicial": "Fecha inicial",
    "Digite sua pergunta...": "Escriba su pregunta...",
    "Distrito Federal": "Distrito Federal",
    "Erro ao carregar opções": "Error al cargar opciones",
    "Erro ao estornar cupom": "Error al revertir el cupón",
    "Erro ao remover pontos": "Error al quitar puntos",
    "Espírito Santo": "Espírito Santo",
    "Estornar": "Revertir",
    "Estornar cupom": "Revertir cupón",
    "Faltaram colunas:": "Faltan columnas:",
    "Faltou a coluna": "Falta la columna",
    "Feedbacks Negativos": "Feedbacks negativos",
    "Feedbacks Positivos": "Feedbacks positivos",
    "Filtros": "Filtros",
    "Frentistas": "Playeros",
    "Gerar": "Generar",
    "Gerar cupom": "Generar cupón",
    "Gerar cupom (admin)": "Generar cupón (admin)",
    "Goiás": "Goiás",
    "Identfid": "Identfid",
    "Importando registros...": "Importando registros...",
    "Importar": "Importar",
    "Importar frentistas": "Importar playeros",
    "Importar planilha": "Importar planilla",
    "Imprimir": "Imprimir",
    "Imprimir Totais": "Imprimir totales",
    "Inserir imagem": "Insertar imagen",
    "Manter atual": "Mantener actual",
    "Maranhão": "Maranhão",
    "Marcar como verificado": "Marcar como verificado",
    "Marcar todos como lidos": "Marcar todos como leídos",
    "Mato Grosso": "Mato Grosso",
    "Mato Grosso do Sul": "Mato Grosso do Sul",
    "Minas Gerais": "Minas Gerais",
    "Métricas de uso e performance do assistente IA": "Métricas de uso y rendimiento del asistente de IA",
    "Nenhum registro": "Ningún registro",
    "Nenhuma notificação recebida": "Ninguna notificación recibida",
    "Nova Senha": "Nueva contraseña",
    "Nova conversa": "Nueva conversación",
    "Não foi possível atualizar o registro": "No se pudo actualizar el registro",
    "Não foi possível carregar o arquivo": "No se pudo cargar el archivo",
    "Não foi possível importar": "No se pudo importar",
    "O local de troca fica igual ao local de origem do cupom. Nenhum código é gerado e nenhuma integração externa é acionada.": "El lugar de canje queda igual al lugar de origen del cupón. No se genera ningún código ni se activa ninguna integración externa.",
    "Os registros abaixo já existem no banco com CPF diferente. Escolha linha a linha ou resolva todos de uma vez.": "Los registros abajo ya existen en la base de datos con un CPF diferente. Elija línea por línea o resuelva todos a la vez.",
    "Paraná": "Paraná",
    "Paraíba": "Paraíba",
    "Pará": "Pará",
    "Pernambuco": "Pernambuco",
    "Piauí": "Piauí",
    "Planilha:": "Planilla:",
    "Pontos removidos com sucesso": "Puntos quitados con éxito",
    "Posso tentar novamente com mais detalhes. Quer que eu busque mais informações?": "Puedo intentarlo de nuevo con más detalles. ¿Quiere que busque más información?",
    "Posto de resgate": "Estación de canje",
    "Recuperar Usuário": "Recuperar usuario",
    "Registro atualizado com sucesso": "Registro actualizado con éxito",
    "Registro mantido sem alteração": "Registro mantenido sin cambios",
    "Relatório do Agente de Suporte": "Reporte del agente de soporte",
    "Relatório gerado em:": "Reporte generado el:",
    "Remover Cupom": "Quitar cupón",
    "Remover cupom": "Quitar cupón",
    "Remover pontos": "Quitar puntos",
    "Reproduz o fluxo do cliente: chama a integração externa (RTI/EVO/Trevo) ou gera código local conforme o posto selecionado.": "Reproduce el flujo del cliente: llama a la integración externa (RTI/EVO/Trevo) o genera un código local según la estación seleccionada.",
    "Rio Grande do Norte": "Río Grande del Norte",
    "Rio Grande do Sul": "Río Grande del Sur",
    "Rio de Janeiro": "Río de Janeiro",
    "Rondônia": "Rondônia",
    "Roraima": "Roraima",
    "Santa Catarina": "Santa Catarina",
    "Satisfação": "Satisfacción",
    "Selecione o posto de resgate": "Seleccione la estación de canje",
    "Selecione uma rede para continuar": "Seleccione una red para continuar",
    "Sergipe": "Sergipe",
    "Sua planilha precisa ter estas colunas": "Su planilla debe tener estas columnas",
    "Substituir pela planilha": "Reemplazar por la planilla",
    "Substituir todos pela planilha": "Reemplazar todos por la planilla",
    "Sâo Paulo": "São Paulo",
    "Só admins": "Solo admins",
    "Taxa de Satisfação": "Tasa de satisfacción",
    "Tem certeza disso? Essa ação não pode ser revertida": "¿Está seguro de esto? Esta acción no se puede revertir",
    "Tentar novamente": "Intentar de nuevo",
    "Tocantins": "Tocantins",
    "Todas as redes": "Todas las redes",
    "Todos os usuários": "Todos los usuarios",
    "Top Usuários": "Top usuarios",
    "Total de Mensagens": "Total de mensajes",
    "Total de Sessões": "Total de sesiones",
    "Total de Tokens": "Total de tokens",
    "Tudo certo —": "Todo listo —",
    "Uso por LLM": "Uso por LLM",
    "Validando o arquivo...": "Validando el archivo...",
    "Validar": "Validar",
    "Validar cupons": "Validar cupones",
    "Vezes Usado": "Veces usado",
    "Visualizar mais": "Ver más",
    "Você não tem permissão para acessar este relatório.": "No tiene permiso para acceder a este reporte.",
    "conflito(s) encontrado(s)": "conflicto(s) encontrado(s)",
    "frentista": "playero",
    "linha(s) ignorada(s)": "línea(s) ignorada(s)",
    "mais": "más",
    "prontos para importar": "listos para importar",
    "ra.notification.deleted": "ra.notification.deleted",
    "✨ Continuar escrevendo com IA": "✨ Continuar escribiendo con IA",
    "✨ Fale com a IA": "✨ Hable con la IA",
    "✨ Ferramentas de edição com IA": "✨ Herramientas de edición con IA",
    "✨ Novo! Assistente IA — pergunte o que quiser": "✨ ¡Nuevo! Asistente de IA — pregunte lo que quiera",
    "🚀 Seu assistente de IA chegou!": "🚀 ¡Llegó su asistente de IA!",
};

export default catalogo;
